<div #inputWrap class="chat-input-container">
  <div class="input-wrap">
    <div class="outer-editor" [class.disabled]="disabled">
      <div
        #editor
        class="editor"
        [attr.contenteditable]="!disabled ? 'true' : false"
        (input)="onInput()"
        (keydown)="onKeyDown($event)"
        placeholder="Type @ to mention"
      ></div>
    </div>
    <div class="emoji-btn" (click)="disabled ? null : toggleEmojiPicker()" [ngClass]="{ disabled: disabled }">
      <i
        [ngClass]="{
          'fi-emoji-happy-filled': displayEmojiPicker,
          'fi-emoji-happy': !displayEmojiPicker,
        }"
      ></i>
    </div>
    <div *ngIf="!!!value" [class.disabled]="disabled" class="placeholder">Type your message</div>
  </div>
  <div *ngIf="showMaxLengthWarning" class="note">You have reached the 512 character limit</div>

  <ng-template #mentionTemplate>
    <ul class="mention-list">
      <li *ngFor="let user of filteredUserList" (click)="handleMentionSelect(user)">
        {{ user.nickname }}
      </li>
    </ul>
  </ng-template>

  <ng-template #emojiTemplate>
    <div class="emoji-picker">
      <span *ngFor="let item of emojiList" (click)="handleEmojiSelect(item)">
        <i>{{ item }}</i>
      </span>
    </div>
  </ng-template>
</div>
